import { useStore } from "../../store/app";
import { IDateRange } from './IDateRange';

export const useDateRangeFilter = () => {

  const dateFilterRange = useStore((state) => state.dateRangeFilter);

  const dateRange = {
    dateRangeType: dateFilterRange.dateRangeType,
    start: new Date(dateFilterRange.start),
    end: new Date(dateFilterRange.end)
  } as IDateRange;

  const setDateRange = (range: IDateRange) => {
    const updatedDateFilterRange = {
      dateRangeType: range.dateRangeType,
      start: range.start.toISOString(),
      end: range.end.toISOString()
    };
    useStore.setState({dateRangeFilter: updatedDateFilterRange});
  };

  const onDateRangeChanged = (range: IDateRange) => {
    setDateRange({ ...range });
  };

  return { dateRange, dateFilterRange, onDateRangeChanged };
};
